// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import AuthProvider from './context/AuthContext';
import AnalyticsProvider from './analytics/AnalyticsProvider';
import App from './App';
import './styles/retailgo-tokens.css';
import './styles/retailgo-foundation.css';
import './styles/retailgo-shell.css';
import './styles/retailgo-screens.css';
import './styles/modal-shell.css';

if (process.env.REACT_APP_ENVIRONMENT === 'development') {
  // require('./api/mockApi');
}

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <AuthProvider>
    <AnalyticsProvider>
      <App />
    </AnalyticsProvider>
  </AuthProvider>
);
